import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, ref } from 'vue'
import baseMessage from '@/views/overseasSales/customerCenter/components/baseMessage.vue'
import { useRoute } from 'vue-router'
import { potentialDetail } from '@/api/overseasSales/customerCenter'

const __default__ = { name: 'DcCosOFbuPotentialPerfect' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute()
const data = ref({})
// 获取详情
const fetch = () => {
  if (route.query.cosId) {
    potentialDetail(route.query.cosId).then((res) => {
      data.value = res.data
    })
  }
}
const permissionBasic = {
  save: 'ofbu_potential_perfect_btn',
  editCode: 'ofbu_perfect_edit_name_or_code_btn'
}
onMounted(() => {
  fetch()
})

return (_ctx: any,_cache: any) => {
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(baseMessage, {
            perfect: true,
            permissionPage: permissionBasic,
            disabled: false,
            data: data.value
          }, null, 8, ["data"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})